/* Product page (templates/product.*): scripts of general-product-grid and everything it renders, in render order.
   Loaded deferred from layout/theme.liquid, so the DOM is complete when each block runs; each block returns when its root is absent. */

/* ===== Product gallery (product-gallery). Public API: window.CFS.productGallery.gotoMediaId(mediaId) ===== */
(function(){
  var root = document.querySelector('[data-cg]');
  var api = { gotoMediaId: function(){} };
  window.CFS = window.CFS || {};
  window.CFS.productGallery = api;
  if (!root) return;

  var main = root.querySelector('.cg-main');
  var track = root.querySelector('.cg-track');
  var slides = track ? [].slice.call(track.children) : [];
  var n = slides.length;
  if (!n) return;

  var rail = root.querySelector('[data-cg-rail]');
  var fade = root.querySelector('[data-cg-fade]');
  var thumbs = rail ? [].slice.call(rail.querySelectorAll('.cg-th')) : [];
  var prevBtn = root.querySelector('.cg-prev');
  var nextBtn = root.querySelector('.cg-next');
  var viewer = document.getElementById(root.id + '-viewer');
  var PID = Number(root.dataset.productId);
  var HANDLE = root.dataset.productHandle;
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileMQ = window.matchMedia('(max-width: 768px)');
  var coarseMQ = window.matchMedia('(pointer: coarse)');
  var cur = 0;

  /* ---------- analytics ---------- */
  /* type defaults to the gallery slide's type; extra adds fields (buyer mode) */
  function publish(name, idx, type, extra){
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        var data = {
          product_id: PID,
          product_handle: HANDLE,
          item_index: idx,
          item_type: type || (slides[idx] ? slides[idx].dataset.type : '')
        };
        if (extra) for (var key in extra) data[key] = extra[key];
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }
  var seen = {};
  function viewEvent(idx){
    if (slides[idx] && slides[idx].dataset.type === 'size' && !seen['size' + idx]) {
      seen['size' + idx] = true;
      publish('gallery_size_view', idx);
    }
  }

  function typeOf(i){ return slides[i] ? slides[i].dataset.type : ''; }
  function isZoomable(i){ return typeOf(i) === 'image'; }

  /* ---------- video facade (iframe / <video> created on tap only) ---------- */
  function stopIn(scope){
    if (!scope) return;
    [].forEach.call(scope.querySelectorAll('.cg-player'), function(p){ p.remove(); });
  }
  function playIn(box, slide){
    if (!box || !slide) return false;
    stopIn(box);
    var host = slide.dataset.host, id = slide.dataset.videoId, player = null, src = null;
    if (host === 'youtube' && id) src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1&rel=0';
    else if (host === 'vimeo' && id) src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
    if (src) {
      player = document.createElement('iframe');
      player.src = src;
      player.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      player.setAttribute('allowfullscreen', '');
      player.title = slide.querySelector('.cg-play') ? slide.querySelector('.cg-play').getAttribute('aria-label') : '';
    } else {
      var tpl = slide.querySelector('template.cg-vtpl');
      var v = tpl && tpl.content.querySelector('video');
      if (v) player = v.cloneNode(true);
    }
    if (!player) return false;
    player.classList.add('cg-player');
    box.appendChild(player);
    if (player.tagName === 'VIDEO' && player.play) { var p = player.play(); if (p && p.catch) p.catch(function(){}); }
    if (player.focus) player.focus({ preventScroll: true });
    return true;
  }

  /* ---------- stage ---------- */
  function setTrack(dx){
    track.style.transform = dx
      ? 'translateX(calc(' + (-cur * 100) + '% + ' + dx + 'px))'
      : 'translateX(' + (-cur * 100) + '%)';
  }
  function prime(i){
    [i - 1, i, i + 1].forEach(function(k){
      if (!slides[k]) return;
      [].forEach.call(slides[k].querySelectorAll('img[loading="lazy"]'), function(img){ img.loading = 'eager'; });
    });
  }
  function scrollThumb(i){
    var t = thumbs[i];
    if (!t || !rail) return;
    var behavior = reduceMQ.matches ? 'auto' : 'smooth';
    if (mobileMQ.matches) {
      rail.scrollTo({ left: t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2, behavior: behavior });
    } else if (t.offsetTop < rail.scrollTop || t.offsetTop + t.offsetHeight > rail.scrollTop + rail.clientHeight) {
      rail.scrollTo({ top: t.offsetTop - (rail.clientHeight - t.offsetHeight) / 2, behavior: behavior });
    }
  }
  function updateFade(){
    if (!fade || !rail) return;
    fade.hidden = mobileMQ.matches || rail.scrollHeight - rail.clientHeight - rail.scrollTop <= 2;
  }

  var primed = false;
  function go(i){
    i = Math.max(0, Math.min(n - 1, i));
    if (i !== cur) stopIn(track);
    cur = i;
    setTrack(0);
    slides.forEach(function(s, k){
      if (k === i) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
      else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
    });
    thumbs.forEach(function(t, k){ t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    if (prevBtn) prevBtn.disabled = i === 0;
    if (nextBtn) nextBtn.disabled = i === n - 1;
    main.classList.toggle('is-zoomable', isZoomable(i));
    if (primed) prime(i);
    scrollThumb(i);
    viewEvent(i);
  }

  thumbs.forEach(function(t, k){ t.addEventListener('click', function(){ go(k); }); });
  if (prevBtn) prevBtn.addEventListener('click', function(){ go(cur - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function(){ go(cur + 1); });
  if (rail) rail.addEventListener('scroll', updateFade, { passive: true });

  track.addEventListener('click', function(e){
    var b = e.target.closest('.cg-play');
    if (!b) return;
    var slide = b.closest('.cg-slide');
    if (playIn(b.closest('.cg-video'), slide)) publish('gallery_video_play', Number(slide.dataset.index));
  });

  main.addEventListener('keydown', function(e){
    if (e.target !== main) return;
    if (e.key === 'ArrowRight' && n > 1) { e.preventDefault(); go(cur + 1); }
    else if (e.key === 'ArrowLeft' && n > 1) { e.preventDefault(); go(cur - 1); }
    else if (e.key === 'Enter') { e.preventDefault(); openViewer(cur); }
  });

  /* swipe (horizontal lock, 18% threshold, rubber-band) + tap to open */
  var sx = null, sy = 0, sdx = 0, lock = null, spid = null;
  main.addEventListener('pointerdown', function(e){
    lastPT = e.pointerType;
    if (e.button) return;
    if (e.target.closest('button, iframe, video, a')) return;
    sx = e.clientX; sy = e.clientY; sdx = 0; lock = null; spid = e.pointerId;
  });
  main.addEventListener('pointermove', function(e){
    if (sx === null || e.pointerId !== spid) return;
    var dx = e.clientX - sx, dy = e.clientY - sy;
    if (lock === null) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      lock = (n > 1 && Math.abs(dx) > Math.abs(dy)) ? 'x' : 'y';
      if (lock === 'x') {
        track.classList.add('is-dragging');
        stopIn(track);
        try { main.setPointerCapture(spid); } catch (err) {}
      }
    }
    if (lock !== 'x') return;
    sdx = dx;
    var d = dx;
    if ((cur === 0 && d > 0) || (cur === n - 1 && d < 0)) d *= 0.35;
    setTrack(d);
  });
  main.addEventListener('pointerup', function(e){
    if (sx === null || e.pointerId !== spid) return;
    var l = lock;
    sx = null;
    track.classList.remove('is-dragging');
    if (l === 'x') {
      if (Math.abs(sdx) > main.offsetWidth * 0.18) go(cur + (sdx < 0 ? 1 : -1));
      else setTrack(0);
    } else if (l === null && isZoomable(cur)) {
      openViewer(cur);
    }
  });
  main.addEventListener('pointercancel', function(){
    if (sx === null) return;
    sx = null;
    track.classList.remove('is-dragging');
    setTrack(0);
  });

  api.gotoMediaId = function(mediaId){
    if (mediaId == null) return;
    var id = String(mediaId);
    for (var k = 0; k < n; k++) {
      if (slides[k].dataset.mediaId === id) { go(k); return; }
    }
  };

  /* ---------- viewer ---------- */
  /* mode 'gallery' shows the stage slides; mode 'buyers' shows only the matching buyer photos */
  var V = { open: false, mode: 'gallery', i: 0, z: 1, ox: 0, oy: 0, img: null, opener: null };
  var vCt, vTt, vBody, vStage, vTip, vStrip, vBuy, vPrice, vAtc, vX, vPrev, vNext, vThumbs = [], gThumbs = [], bThumbs = [];
  var buyers = [];
  var lastPT = 'mouse';

  if (viewer) {
    document.body.appendChild(viewer); /* escape the sticky column's stacking context */
    buyers = [].map.call(viewer.querySelectorAll('.cgv-bdata > i'), function(el){ return el.dataset; });
    vCt = viewer.querySelector('.cgv-ct');
    vTt = viewer.querySelector('.cgv-tt');
    vBody = viewer.querySelector('.cgv-body');
    vStage = viewer.querySelector('.cgv-stage');
    vTip = viewer.querySelector('.cgv-tip');
    vStrip = viewer.querySelector('.cgv-strip');
    vBuy = viewer.querySelector('.cgv-buy');
    vPrice = viewer.querySelector('.cgv-price');
    vAtc = viewer.querySelector('.cgv-atc');
    vX = viewer.querySelector('.cgv-x');
    vPrev = viewer.querySelector('[data-vstep="-1"]');
    vNext = viewer.querySelector('[data-vstep="1"]');
    if (vStrip) {
      thumbs.forEach(function(t, k){
        var c = t.cloneNode(true);
        c.addEventListener('click', function(){ vShow(k); });
        gThumbs.push(c);
      });
    }
  }

  function vN(){ return V.mode === 'buyers' ? buyers.length : n; }
  function vZoomable(i){ return V.mode === 'buyers' || isZoomable(i); }

  /* buyer strip thumbnails are built on first open so their images don't load with the page */
  function buyerThumbs(){
    if (bThumbs.length || !vStrip) return bThumbs;
    buyers.forEach(function(b, k){
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'cg-th';
      c.setAttribute('aria-label', b.alt);
      c.setAttribute('aria-current', 'false');
      var im = document.createElement('img');
      im.alt = '';
      im.draggable = false;
      im.decoding = 'async';
      im.src = b.thumb;
      c.appendChild(im);
      c.addEventListener('click', function(){ vShow(k); });
      bThumbs.push(c);
    });
    return bThumbs;
  }

  function setMode(mode){
    V.mode = mode === 'buyers' && buyers.length ? 'buyers' : 'gallery';
    var b = V.mode === 'buyers';
    vTt.textContent = b ? viewer.dataset.buyersTitle : viewer.dataset.title;
    viewer.setAttribute('aria-label', b ? viewer.dataset.buyersTitle : viewer.dataset.label);
    vThumbs = b ? buyerThumbs() : gThumbs;
    if (vStrip) {
      vStrip.innerHTML = '';
      vThumbs.forEach(function(c){ vStrip.appendChild(c); });
      vStrip.hidden = vN() < 2;
    }
    if (vPrev) vPrev.hidden = vN() < 2;
    if (vNext) vNext.hidden = vN() < 2;
  }

  function buyButton(){ return document.querySelector('.sticky-buy-box [data-add-to-checkout]'); }

  function applyT(){
    if (!V.img) return;
    V.img.style.transform = V.z > 1 ? 'translate(' + V.ox + 'px,' + V.oy + 'px) scale(' + V.z + ')' : '';
    V.img.classList.toggle('is-zoomed', V.z > 1);
  }
  function base(){
    var r = vBody.getBoundingClientRect();
    return { l: r.left + V.img.offsetLeft, t: r.top + V.img.offsetTop, w: V.img.offsetWidth, h: V.img.offsetHeight };
  }
  function clampPan(b){
    if (V.z <= 1.02) { V.z = 1; V.ox = 0; V.oy = 0; return; }
    V.ox = Math.min(0, Math.max(b.w - b.w * V.z, V.ox));
    V.oy = Math.min(0, Math.max(b.h - b.h * V.z, V.oy));
  }
  function zoomTo(z2, cx, cy){
    if (!V.img) return;
    var b = base();
    var lx = (cx - b.l - V.ox) / V.z, ly = (cy - b.t - V.oy) / V.z;
    V.z = z2;
    V.ox = cx - b.l - lx * z2;
    V.oy = cy - b.t - ly * z2;
    clampPan(b);
    applyT();
  }
  function unzoom(){ V.z = 1; V.ox = 0; V.oy = 0; applyT(); }

  function vShow(i){
    var vn = vN();
    i = Math.max(0, Math.min(vn - 1, i));
    V.i = i; V.z = 1; V.ox = 0; V.oy = 0; V.img = null;
    vBody.innerHTML = '';
    vBody.style.transform = '';
    var s = slides[i], t = s ? s.dataset.type : '';
    if (V.mode === 'buyers') {
      var bp = buyers[i];
      var bi = document.createElement('img');
      bi.className = 'cgv-img';
      bi.alt = bp.alt;
      bi.draggable = false;
      bi.decoding = 'async';
      bi.setAttribute('width', bp.w);
      bi.setAttribute('height', bp.h);
      bi.src = bp.src;
      vBody.appendChild(bi);
      V.img = bi;
      if (bp.cap) {
        var cap = document.createElement('span');
        cap.className = 'cgv-cap';
        cap.textContent = bp.cap;
        vBody.appendChild(cap);
      }
      if (!seen['buyer:' + bp.handle]) {
        seen['buyer:' + bp.handle] = true;
        publish('gallery_customer_view', i, 'customer');
      }
    } else if (t === 'image') {
      var srcImg = s.querySelector('img');
      var im = document.createElement('img');
      im.className = 'cgv-img';
      im.alt = srcImg.alt;
      im.draggable = false;
      im.decoding = 'async';
      im.setAttribute('width', srcImg.getAttribute('width'));
      im.setAttribute('height', srcImg.getAttribute('height'));
      im.src = srcImg.currentSrc || srcImg.getAttribute('src');
      var large = s.dataset.large;
      if (large) {
        var pre = new Image();
        pre.onload = function(){ if (V.img === im) im.src = large; };
        pre.src = large;
      }
      vBody.appendChild(im);
      V.img = im;
    } else if (t === 'video') {
      var w = document.createElement('div');
      w.className = 'cgv-vid';
      var box = s.querySelector('.cg-video').cloneNode(true);
      stopIn(box);
      [].forEach.call(box.querySelectorAll('img'), function(x){ x.loading = 'eager'; });
      w.appendChild(box);
      vBody.appendChild(w);
    } else if (t === 'size') {
      var c = s.cloneNode(true);
      c.removeAttribute('inert');
      c.removeAttribute('aria-hidden');
      [].forEach.call(c.querySelectorAll('img'), function(x){ x.loading = 'eager'; });
      vBody.appendChild(c);
    }
    vCt.textContent = (i + 1) + ' / ' + vn;
    if (vPrev) vPrev.disabled = i === 0;
    if (vNext) vNext.disabled = i === vn - 1;
    vThumbs.forEach(function(th, k){ th.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var vt = vThumbs[i];
    if (vt && vStrip.scrollWidth > vStrip.clientWidth) {
      vStrip.scrollTo({ left: vt.offsetLeft - (vStrip.clientWidth - vt.offsetWidth) / 2, behavior: reduceMQ.matches ? 'auto' : 'smooth' });
    }
    if (vZoomable(i)) {
      vTip.textContent = (mobileMQ.matches || coarseMQ.matches) ? viewer.dataset.hintMobile : viewer.dataset.hintDesktop;
      vTip.hidden = false;
    } else {
      vTip.hidden = true;
    }
    if (V.mode === 'gallery') viewEvent(i);
  }

  function onDocKey(e){
    if (!V.open) return;
    if (e.key === 'Escape') { e.preventDefault(); closeViewer(); return; }
    if (e.key === 'ArrowRight' && vN() > 1) { e.preventDefault(); vShow(V.i + 1); return; }
    if (e.key === 'ArrowLeft' && vN() > 1) { e.preventDefault(); vShow(V.i - 1); return; }
    if (e.key === 'Tab') {
      var f = [].filter.call(viewer.querySelectorAll('button, [href], iframe, video[controls], [tabindex]:not([tabindex="-1"])'), function(el){
        return !el.disabled && el.getClientRects().length > 0;
      });
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1], act = document.activeElement;
      if (!viewer.contains(act)) { e.preventDefault(); a.focus(); }
      else if (e.shiftKey && act === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && act === z) { e.preventDefault(); a.focus(); }
    }
  }

  function openViewer(i, mode, opener){
    if (!viewer || V.open) return;
    stopIn(track);
    setMode(mode);
    V.opener = opener || null;
    var btn = buyButton();
    if (btn) {
      var lblEl = btn.querySelector('.cta-text') || btn;
      var lbl = lblEl.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      lbl = lbl.charAt(0).toUpperCase() + lbl.slice(1);
      var priceEl = document.querySelector('.price-panel.v2 .sale, .price-panel.v2 .sale-show');
      var price = priceEl ? priceEl.textContent.replace(/\s+/g, '') : '';
      vPrice.textContent = price;
      vPrice.hidden = !price;
      vAtc.textContent = lbl;
      vBuy.hidden = !lbl;
    } else {
      vBuy.hidden = true;
    }
    V.open = true;
    viewer.hidden = false;
    document.documentElement.classList.add('cg-lock');
    document.addEventListener('keydown', onDocKey);
    vShow(i);
    if (V.mode === 'gallery') publish('gallery_viewer_open', i);
    vX.focus({ preventScroll: true });
  }

  function closeViewer(){
    if (!V.open) return;
    V.open = false;
    vBody.innerHTML = '';
    V.img = null;
    viewer.hidden = true;
    document.documentElement.classList.remove('cg-lock');
    document.removeEventListener('keydown', onDocKey);
    /* buyer mode leaves the gallery on its slide and returns focus to the button or tile that opened it */
    var back = main;
    if (V.mode === 'gallery') go(V.i);
    else if (V.opener && V.opener.getClientRects().length) back = V.opener;
    back.focus({ preventScroll: true });
  }

  /* buyer photo tiles: stage overlay (desktop) and first in the strip (mobile), one visible per viewport;
     not media items, so not in thumbs. Stopping propagation keeps the stage from swiping or opening the product viewer */
  [].forEach.call(root.querySelectorAll('[data-buyers]'), function(b){
    b.addEventListener('pointerdown', function(e){ e.stopPropagation(); lastPT = e.pointerType; });
    b.addEventListener('click', function(e){
      e.stopPropagation();
      if (!buyers.length) return;
      publish('gallery_buyers_open', 0, 'customer', { photo_count: buyers.length, entry_point: b.dataset.buyers });
      openViewer(0, 'buyers', b);
    });
  });

  if (viewer) {
    vX.addEventListener('click', closeViewer);
    if (vPrev) vPrev.addEventListener('click', function(){ vShow(V.i - 1); });
    if (vNext) vNext.addEventListener('click', function(){ vShow(V.i + 1); });
    vAtc.addEventListener('click', function(){
      publish('gallery_viewer_add_to_cart', V.i, V.mode === 'buyers' ? 'customer' : '');
      closeViewer();
      var b = buyButton();
      if (b) b.click();
    });
    vBody.addEventListener('click', function(e){
      var pb = e.target.closest('.cg-play');
      if (pb) {
        if (playIn(pb.closest('.cg-video'), slides[V.i])) publish('gallery_video_play', V.i);
        return;
      }
      /* desktop: click zooms 2.5x at the pointer, second click zooms out */
      if (lastPT !== 'mouse' || !V.img || e.target !== V.img) return;
      if (V.z > 1) unzoom(); else zoomTo(2.5, e.clientX, e.clientY);
    });
    vStage.addEventListener('mousemove', function(e){
      if (lastPT !== 'mouse' || V.z <= 1 || !V.img) return;
      var r = vStage.getBoundingClientRect(), b = base();
      var fx = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      var fy = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
      V.ox = -(b.w * V.z - b.w) * fx;
      V.oy = -(b.h * V.z - b.h) * fy;
      applyT();
    });

    /* touch: swipe (70px), double-tap zoom 2.5x, pinch 1-3x, drag pan while zoomed */
    var pts = {}, g = null, lastTap = 0, lastTapX = 0, lastTapY = 0;
    function ptList(){ return Object.keys(pts).map(function(k){ return pts[k]; }); }
    vStage.addEventListener('pointerdown', function(e){
      lastPT = e.pointerType;
      if (e.pointerType === 'mouse') return;
      if (e.target.closest('button, iframe, video')) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { vStage.setPointerCapture(e.pointerId); } catch (err) {}
      var list = ptList();
      if (list.length === 2 && V.img) {
        vBody.style.transform = '';
        g = { type: 'pinch', d0: Math.hypot(list[0].x - list[1].x, list[0].y - list[1].y) || 1, z0: V.z };
        return;
      }
      if (list.length !== 1) return;
      var now = Date.now();
      if (V.img && now - lastTap < 300 && Math.hypot(e.clientX - lastTapX, e.clientY - lastTapY) < 30) {
        lastTap = 0;
        if (V.z > 1) unzoom(); else zoomTo(2.5, e.clientX, e.clientY);
        g = null;
        return;
      }
      lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY;
      g = V.z > 1
        ? { type: 'pan', x: e.clientX, y: e.clientY, ox: V.ox, oy: V.oy }
        : { type: 'swipe', x: e.clientX, dx: 0 };
    });
    vStage.addEventListener('pointermove', function(e){
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (!g) return;
      if (g.type === 'pinch') {
        var l = ptList();
        if (l.length < 2) return;
        var d = Math.hypot(l[0].x - l[1].x, l[0].y - l[1].y);
        var z2 = Math.max(1, Math.min(3, g.z0 * d / g.d0));
        zoomTo(z2, (l[0].x + l[1].x) / 2, (l[0].y + l[1].y) / 2);
      } else if (g.type === 'pan') {
        V.ox = g.ox + (e.clientX - g.x);
        V.oy = g.oy + (e.clientY - g.y);
        clampPan(base());
        applyT();
      } else if (g.type === 'swipe' && vN() > 1) {
        g.dx = e.clientX - g.x;
        vBody.style.transform = 'translateX(' + g.dx + 'px)';
      }
    });
    function vEnd(e){
      if (!pts[e.pointerId]) return;
      delete pts[e.pointerId];
      if (!g) return;
      if (g.type === 'swipe') {
        var dx = g.dx;
        g = null;
        vBody.style.transform = '';
        if (vN() > 1 && Math.abs(dx) > 70) vShow(V.i + (dx < 0 ? 1 : -1));
      } else if (g.type === 'pinch') {
        var rest = ptList();
        if (V.z <= 1.02) unzoom();
        g = rest.length === 1 && V.z > 1 ? { type: 'pan', x: rest[0].x, y: rest[0].y, ox: V.ox, oy: V.oy } : null;
      } else if (!ptList().length) {
        g = null;
      }
    }
    vStage.addEventListener('pointerup', vEnd);
    vStage.addEventListener('pointercancel', vEnd);
  }

  /* ---------- desktop: fit stage + rail in the first screen ---------- */
  /* --cg-max = window height below the gallery's top as placed in the document (scroll 0), minus 16px.
     Inside a sticky column the gallery's current top moves with scroll, so measure from the column's parent instead. */
  function fit(){
    if (mobileMQ.matches) { root.style.removeProperty('--cg-max'); return; }
    var top = root.getBoundingClientRect().top;
    var stick = root.parentElement;
    while (stick && stick !== document.body && getComputedStyle(stick).position !== 'sticky') stick = stick.parentElement;
    if (stick && stick !== document.body && stick.parentElement) {
      top = stick.parentElement.getBoundingClientRect().top + (top - stick.getBoundingClientRect().top);
    }
    var avail = window.innerHeight - (top + window.scrollY) - 16;
    root.style.setProperty('--cg-max', Math.max(360, Math.floor(avail)) + 'px');
  }

  /* ---------- init: fit now (deferred, DOM complete) and again on load ---------- */
  fit();
  go(0);
  updateFade();
  var fitT;
  window.addEventListener('resize', function(){
    setTrack(0);
    updateFade();
    clearTimeout(fitT);
    fitT = setTimeout(function(){ fit(); updateFade(); }, 150);
  }, { passive: true });
  function primeNow(){ primed = true; prime(cur); fit(); updateFade(); }
  if (document.readyState === 'complete') primeNow();
  else window.addEventListener('load', primeNow, { once: true });
})();

/* ===== Cart discount codes (shared by the promo line and the pop-up offer). Public API: window.CFS.cartCodes
   .read() → the cart's codes or null; .add(code, bannerText) / .remove(code, bannerText) merge one code in or out ===== */
(() => {
  // The cart's current discount codes (trimmed, de-duplicated case-insensitively),
  // or null when /cart.js can't be read.
  function readCartCodes() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((res) => (res.ok ? res.json() : null))
      .then((cart) => {
        if (!cart || !Array.isArray(cart.discount_codes)) return null;
        const seen = new Set();
        const codes = [];
        cart.discount_codes.forEach((entry) => {
          const code = entry && typeof entry.code === 'string' ? entry.code.trim() : '';
          const key = code.toLowerCase();
          if (!code || seen.has(key)) return;
          seen.add(key);
          codes.push(code);
        });
        return codes;
      })
      .catch(() => null);
  }

  async function updateCartCode(code, applied, bannerText) {
    // /cart/update.js accepts a `discount` param that applies (or, when empty,
    // clears) discount codes on the cart itself — unlike /discount/{code},
    // which only sets it for the next checkout and never shows in the cart.
    // It takes several codes as one comma-separated string, so this merges:
    // add puts this code with the codes already on the cart, and remove
    // takes out only this code. If the cart can't be read, it falls back to
    // posting this code alone (or clearing on remove).
    // bannerText (when given) rides along as the promo_banner_text cart
    // attribute so the cart drawer can show the promo's own copy instead of
    // the raw discount code; callers that omit it leave the attribute alone.
    const ownKey = code.trim().toLowerCase();
    const existing = await readCartCodes();

    let discount;
    if (existing) {
      const codes = existing.filter((c) => c.toLowerCase() !== ownKey);
      if (applied) codes.push(code);
      discount = codes.join(',');
    } else {
      discount = applied ? code : '';
    }

    const body = { discount };
    if (bannerText !== undefined) body.attributes = { promo_banner_text: bannerText };

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).catch(() => {});
  }

  window.CFS = window.CFS || {};
  window.CFS.cartCodes = {
    read: readCartCodes,
    add: (code, bannerText) => updateCartCode(code, true, bannerText),
    remove: (code, bannerText) => updateCartCode(code, false, bannerText)
  };
})();

/* ===== Promo line (product-hero-promo-line): Claim applies the discount to the cart, dispatches cfs:promo-change ===== */
(() => {
  const root = document.querySelector('[data-promo-root]');
  if (!root) return;

  const badgeText = root.dataset.badgeText;
  const messageText = root.dataset.messageText;
  const discountCode = root.dataset.discountCode;
  const labelClaim = root.dataset.labelClaim;
  const labelApplied = root.dataset.labelApplied + ' ✓';

  const btn = root.querySelector('[data-promo-cta]');
  const label = root.querySelector('[data-promo-apply-label]');

  // First sentence-ending period — i.e. a "." followed by whitespace/end,
  // so decimal prices like "$2,000.00" don't get mistaken for a sentence break.
  const SENTENCE_END = /\.(?=\s|$)/;

  function firstSentence(text) {
    const match = text.match(SENTENCE_END);
    return match ? text.slice(0, match.index + 1) : text;
  }

  function findRealATC() {
    return document.querySelector('.sticky-buy-box [data-add-to-checkout]')
      || document.querySelector('form[action*="/cart/add"] button[type="submit"]')
      || document.querySelector('#stickyATC [data-add-to-checkout]');
  }

  function triggerATC() {
    const realBtn = findRealATC();
    if (realBtn) realBtn.click();
  }

  function updateCartDiscount(applied) {
    // Claim merges this line's code into the cart's codes, un-claiming removes
    // only this line's code (window.CFS.cartCodes, above). The banner text
    // always rides along (blank on un-claim) so the cart drawer can show the
    // promo's own copy instead of the raw discount code.
    const bannerText = applied ? firstSentence(messageText).replace(/\*/g, '').trim() : '';
    return applied
      ? window.CFS.cartCodes.add(discountCode, bannerText)
      : window.CFS.cartCodes.remove(discountCode, bannerText);
  }

  async function setApplied(applied) {
    root.classList.toggle('is-applied', applied);
    btn.setAttribute('aria-pressed', String(applied));
    label.textContent = applied ? labelApplied : labelClaim;
    document.dispatchEvent(new CustomEvent('cfs:promo-change', { detail: { applied, badge: badgeText } }));

    if (!discountCode) {
      if (applied) triggerATC();
      return;
    }

    // Apply/clear the discount on the cart first so the add-to-cart drawer
    // refresh right after picks up the correct discounted total.
    await updateCartDiscount(applied);

    if (applied) {
      triggerATC();
    } else {
      window.cdfRefreshCart?.();
    }
  }

  btn.addEventListener('click', () => {
    setApplied(!root.classList.contains('is-applied'));
  });
})();

/* ===== Family switcher (product-hero-family-switcher): pill / option targets follow the selected colour ===== */
(function(){
  var root = document.querySelector('.pfam[data-block="family-switcher"]');
  if (!root) return;

  function applyColor(color){
    if (!color) return;
    var key = String(color).trim().toLowerCase();

    root.querySelectorAll('[data-variant-map]').forEach(function(el){
      var map = {};
      try { map = JSON.parse(el.getAttribute('data-variant-map') || '{}'); } catch (e) {}

      var baseUrl = el.getAttribute('data-base-url');
      var vid = map[key];
      var href = vid ? (baseUrl + '?variant=' + vid) : baseUrl;

      if (el.tagName === 'A') {
        el.setAttribute('href', href);
      } else if (el.tagName === 'OPTION') {
        el.value = href;
      }
    });
  }

  function currentSelectedColor(){
    var checkedSwatch = document.querySelector('.cswatch-input:checked');
    if (checkedSwatch) return checkedSwatch.value;
    return root.getAttribute('data-initial-color');
  }

  // Rewire pill/option targets whenever the product's own color changes
  // in place (dispatched by the color swatch picker without a page nav).
  document.addEventListener('variant:change', function(){
    applyColor(currentSelectedColor());
  });

  // Initial sync (also covers ?variant= already in the URL on load, and bfcache restores).
  applyColor(currentSelectedColor());
  window.addEventListener('pageshow', function(){
    applyColor(currentSelectedColor());
  });

  var select = root.querySelector('.pfam-select');
  if (select) {
    select.addEventListener('change', function(e){
      var url = e.target.value;
      if (url) window.location.href = url;
    });
  }
})();

/* ===== Colour twins (product-hero-color-twins): tile click prefetches and navigates; painted dots for twins without a photo ===== */
(function(){
  const block = document.querySelector('.vdd[data-block="color-twins"]');
  const row   = block?.querySelector('.vdd-swatches');
  if (!row) return;
  const vopts   = block.closest('.vopts');
  const label   = block.querySelector('.vdd-color-label strong');
  const tiles   = row.querySelectorAll('.vdd-swatch');
  const pressedName = () => row.querySelector('[aria-pressed="true"]')?.getAttribute('aria-label') || '';

  function setLoading(on){
    if (on){
      block.setAttribute('data-loading','1');
      vopts?.classList.add('is-loading');
    } else {
      block.removeAttribute('data-loading');
      if (!vopts?.querySelector('.vdd[data-loading="1"]')) vopts?.classList.remove('is-loading');
    }
  }
  window.addEventListener('pageshow', () => setLoading(false));

  function warm(url){
    try{
      const l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = new URL(url, window.location.origin).href;
      document.head.appendChild(l);
    }catch{}
  }

  tiles.forEach(a => {
    a.addEventListener('mouseenter', () => { if (label) label.textContent = a.getAttribute('aria-label'); });
    a.addEventListener('mouseleave', () => { if (label) label.textContent = pressedName(); });
    a.addEventListener('keydown', e => { if (e.key === ' '){ e.preventDefault(); a.click(); } });
    a.addEventListener('click', e => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return; // new tab / window
      e.preventDefault();
      if (a.getAttribute('aria-pressed') === 'true') return;
      tiles.forEach(b => b.setAttribute('aria-pressed','false'));
      a.setAttribute('aria-pressed','true');
      setLoading(true);
      warm(a.href);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.location.href = a.href;
        });
      });
    });
  });

  // Painted dots only for twins without a photo (CFS.COLOR_MAP is defined in the footer, before this deferred file runs).
  const dots = row.querySelectorAll('.vdd-swatch__dot[data-color-name]');
  if (!dots.length) return;
  function resolveColors(name){
    const key = String(name || '').trim().toLowerCase();
    const map = (window.CFS && window.CFS.COLOR_MAP) || {};
    if (map[key]) return map[key];
    if (window.CSS && CSS.supports && CSS.supports('color', key)) return [key];
    return null;
  }
  dots.forEach(el => {
    const colors = resolveColors(el.getAttribute('data-color-name'));
    if (!colors || !colors.length) return;
    el.style.setProperty('--vdd-swatch-bg', colors.length > 1
      ? 'linear-gradient(135deg, ' + colors[0] + ' 0 50%, ' + colors[1] + ' 50% 100%)'
      : colors[0]);
  });
})();

/* ===== Colour swatches (product-hero-color-swatches): in-place variant change (price panel, gallery, add-to-cart ids) ===== */
(function(){
  var root = document.querySelector('.cswatch[data-block="color-swatches"]');
  if (!root) return;

  function resolveColors(name){
    var key = String(name || '').trim().toLowerCase();
    var map = (window.CFS && window.CFS.COLOR_MAP) || {};
    if (map[key]) return map[key];
    if (window.CSS && CSS.supports && CSS.supports('color', key)) return [key];
    return null;
  }

  // Painted dots only for variants without a photo (CFS.COLOR_MAP from global-js.liquid in the footer is already defined).
  root.querySelectorAll('.cswatch-swatch--dot[data-color-name]').forEach(function(el){
    var colors = resolveColors(el.getAttribute('data-color-name'));
    if (!colors || !colors.length) return;
    var bg = colors.length > 1
      ? 'linear-gradient(135deg, ' + colors[0] + ' 0 50%, ' + colors[1] + ' 50% 100%)'
      : colors[0];
    el.style.setProperty('--cswatch-bg', bg);
  });

  var selectedLabel = root.querySelector('[data-cswatch-selected]');

  // Hover shows that colour's name in the label; moving off restores the selected one.
  root.querySelectorAll('.cswatch-swatch-label').forEach(function(tile){
    var input = document.getElementById(tile.getAttribute('for'));
    if (!input || !selectedLabel) return;
    tile.addEventListener('mouseenter', function(){ selectedLabel.textContent = input.value; });
    tile.addEventListener('mouseleave', function(){
      var checked = root.querySelector('.cswatch-input:checked');
      if (checked) selectedLabel.textContent = checked.value;
    });
  });
  var productUrl = root.getAttribute('data-product-url');
  var sectionId = root.getAttribute('data-section-id');

  var variantMediaMap = {};
  try {
    var mapEl = root.querySelector('[data-cswatch-variant-media]');
    (JSON.parse(mapEl ? mapEl.textContent : '[]')).forEach(function(row){
      variantMediaMap[row.variantId] = row.mediaId;
    });
  } catch (e) {}

  function variantIdFromUrl(url){
    try {
      var params = new URL(url, window.location.origin).searchParams;
      return params.get('variant');
    } catch (e) {
      return null;
    }
  }

  function setAtcVariantId(variantId){
    document.querySelectorAll('[data-add-to-checkout]').forEach(function(btn){
      btn.setAttribute('data-variant-id', variantId);
    });
    window.Shopify = window.Shopify || {};
    window.Shopify.theme = window.Shopify.theme || {};
    window.Shopify.theme.product = window.Shopify.theme.product || {};
    window.Shopify.theme.product.variant = { id: variantId };
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: variantId } }));
  }

  function swapPriceMarkup(html){
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var newPanel = parsed.querySelector('.price-panel.v2');
    var curPanel = document.querySelector('.price-panel.v2');
    if (newPanel && curPanel) curPanel.outerHTML = newPanel.outerHTML;
    var newAtc = parsed.querySelector('[data-add-to-checkout]');
    if (newAtc) setAtcVariantId(newAtc.getAttribute('data-variant-id'));
  }

  function updateInPlace(variantId, url){
    var curPanel = document.querySelector('.price-panel.v2');
    if (curPanel) curPanel.classList.add('cswatch-is-updating');

    var mediaId = variantMediaMap[variantId];
    if (mediaId && window.CFS && window.CFS.productGallery) {
      window.CFS.productGallery.gotoMediaId(mediaId);
    }

    if (!productUrl || !sectionId) {
      window.location.href = url;
      return;
    }

    var fetchUrl = productUrl + '?variant=' + encodeURIComponent(variantId) + '&section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl)
      .then(function(res){
        if (!res.ok) throw new Error('bad response');
        return res.text();
      })
      .then(function(html){
        swapPriceMarkup(html);
        history.replaceState({}, '', url);
      })
      .catch(function(){
        window.location.href = url;
      })
      .finally(function(){
        if (curPanel) curPanel.classList.remove('cswatch-is-updating');
      });
  }

  root.querySelectorAll('.cswatch-input').forEach(function(input){
    input.addEventListener('change', function(){
      var url = input.getAttribute('data-product-url');
      if (selectedLabel) selectedLabel.textContent = input.value;
      if (!url) return;

      var variantId = variantIdFromUrl(url);
      if (!variantId) {
        window.location.href = url;
        return;
      }

      updateInPlace(variantId, url);
    });
  });
})();

/* ===== Order options (order-options): validation + window.CFS.orderOptions for the add-to-cart paths ===== */
(function(){
  var root = document.querySelector('.vopts[data-block="order-options"]');
  if (!root) return;

  var selects = Array.prototype.slice.call(root.querySelectorAll('[data-order-option]'));
  var errorTemplate = root.getAttribute('data-error-template') || '%label%';

  function clearError(select){
    select.removeAttribute('aria-invalid');
    var err = document.getElementById(select.getAttribute('aria-describedby'));
    if (err) { err.hidden = true; err.textContent = ''; }
  }

  function showError(select){
    select.setAttribute('aria-invalid', 'true');
    var err = document.getElementById(select.getAttribute('aria-describedby'));
    if (err) {
      err.hidden = false;
      var label = (select.getAttribute('data-order-option-label') || 'option').toLowerCase();
      err.textContent = errorTemplate.replace('%label%', function(){ return label; });
    }
  }

  // Centre the select on screen (scroll-margin-top keeps it below the compact
  // header), then focus it without a second jump once the scroll has run.
  function reveal(select){
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var done = false;
    function focusIt(){
      if (done) return;
      done = true;
      window.removeEventListener('scrollend', focusIt);
      select.focus({ preventScroll: true });
    }
    if ('onscrollend' in window) window.addEventListener('scrollend', focusIt);
    setTimeout(focusIt, still ? 0 : 700); // no scrollend when nothing had to move
    select.scrollIntoView({ block: 'center', behavior: still ? 'auto' : 'smooth' });
  }

  selects.forEach(function(select){
    select.addEventListener('change', function(){ clearError(select); });
  });

  // Exposed for crawford-cart-drawer.js (addFromBuyBox), which merges collect()
  // into the properties it posts to /cart/add.js and calls validateAndReport()
  // to block the add when a required choice is missing. The sticky bar posts
  // nothing itself; it clicks the main button.
  window.CFS = window.CFS || {};
  window.CFS.orderOptions = {
    // true/false — paints our inline "Choose a …" error on every invalid
    // select (no native bubble) and brings the first one into view.
    validateAndReport: function(){
      var first = null;
      selects.forEach(function(select){
        clearError(select);
        if (!select.checkValidity()) {
          if (!first) first = select;
          showError(select);
        }
      });
      if (first) reveal(first);
      return !first;
    },
    // { "Label": "chosen value", ... } for every select with a non-empty value.
    collect: function(){
      var properties = {};
      selects.forEach(function(select){
        var key = select.getAttribute('data-order-option-label');
        if (key && select.value !== '') properties[key] = select.value;
      });
      return properties;
    }
  };
})();

/* ===== Delivery lines (product-hero-stock-shipping): same-day countdown and arrival range, dispatches cfs:ship-change.
   Ship days are data-days weekdays not listed in data-holidays (store dates); the cutoff, next ship day and
   arrival range all skip holidays. Same-day: under 24 hours to the next cutoff → countdown (data-tpl-cd-today /
   -tomorrow) on line 2 and the long range on line 3; otherwise one line data-tpl-on · arrives (short range).
   Not same-day (and freight): one line, ships in data-ship-range business days (1–3 when absent), then
   data-transit; freight keeps its server-rendered note in the tail when there are no dates. ===== */
(function(){
  var blocks = document.querySelectorAll('.avail-block[data-in-stock="true"]');
  if (!blocks.length) return;

  var fmtRange = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' });
  var fmtDate  = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' });
  var fmtDay   = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long' });
  var fmtShort = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short' });
  var tomorrowWord = '';
  try { tomorrowWord = new Intl.RelativeTimeFormat('en-US', { numeric: 'auto' }).format(1, 'day'); } catch (e) {}

  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Escape the template, then drop the values into its {placeholders}
  // (bold unless the key is listed in `plain`).
  function fill(tpl, values, plain){
    var html = esc(tpl);
    Object.keys(values).forEach(function(k){
      var v = esc(values[k]);
      html = html.split('{' + k + '}').join(plain && plain.indexOf(k) !== -1 ? v : '<b>' + v + '</b>');
    });
    return html;
  }

  // Calendar dates are plain UTC midnights for the store-timezone date, so
  // adding days never trips over DST or the shopper's own timezone.
  function nowIn(tz){
    var out = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function(p){ out[p.type] = parseInt(p.value, 10); });
    return { date: new Date(Date.UTC(out.year, out.month - 1, out.day)), minutes: (out.hour % 24) * 60 + out.minute };
  }
  function addDays(d, n){ var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }

  function update(block){
    var tz = (block.dataset.tz || '').trim();
    var days = [];
    try { days = JSON.parse(block.dataset.days || '[]').map(function(s){ return String(s).trim(); }); } catch (e) {}
    if (!tz || !days.length) return;
    // Store holidays (data-holidays, YYYY-MM-DD store dates) are never ship days; bad or missing JSON = none.
    var holidays = [];
    try { holidays = JSON.parse(block.dataset.holidays || '[]').map(function(s){ return String(s).trim(); }); } catch (e) { holidays = []; }

    // d is a UTC midnight of a store date, so its UTC YYYY-MM-DD is the store date.
    function isShipDay(d){ return days.indexOf(fmtShort.format(d)) !== -1 && holidays.indexOf(d.toISOString().slice(0, 10)) === -1; }
    function nextShipDay(d){ var x = addDays(d, 1); var guard = 0; while (!isShipDay(x) && guard++ < 14) x = addDays(x, 1); return x; }
    function addShipDays(d, n){ var x = d; for (var i = 0; i < n; i++) x = nextShipDay(x); return x; }

    var now;
    try { now = nowIn(tz); } catch (e) { return; }
    var today = now.date;
    var tomorrow = addDays(today, 1);

    var transit = (block.dataset.transit || '').match(/\d+/g) || [];
    var tLow = transit.length ? parseInt(transit[0], 10) : NaN;
    var tHigh = transit.length > 1 ? parseInt(transit[1], 10) : tLow;

    var ship = (block.dataset.shipRange || '').match(/\d+/g) || [];
    var sLow = ship.length ? parseInt(ship[0], 10) : 1;
    var sHigh = ship.length > 1 ? parseInt(ship[1], 10) : (ship.length ? sLow : 3);

    var freight = block.dataset.freight === 'true';
    var shipEl = block.querySelector('[data-avail-ship]');
    var tailEl = block.querySelector('[data-avail-tail]');
    var tailText = tailEl && tailEl.querySelector('[data-avail-tail-text]');
    var arriveEl = block.querySelector('[data-avail-arrive]');
    var tplArrives = (block.dataset.tplArrives || '').trim();
    var short = '';
    var start, end;
    // One line = "{ship part} · Arrives {short range}" on line 2; otherwise line 2 + the long range on line 3.
    var oneLine = true;

    if (block.dataset.sameDay === 'true' && !freight){
      // Next cutoff: today's if today ships and it's not past yet, else the next ship day's.
      var cutoff = parseInt(block.dataset.cutoff, 10) * 60;
      var shipDate, left = Infinity;
      if (!isNaN(cutoff) && isShipDay(today) && now.minutes < cutoff){
        shipDate = today;
        left = cutoff - now.minutes;
      } else {
        shipDate = nextShipDay(today);
        if (!isNaN(cutoff)) left = Math.round((shipDate - today) / 864e5) * 1440 + cutoff - now.minutes;
      }
      var isTomorrow = shipDate.getTime() === tomorrow.getTime();
      var time = (Math.floor(left / 60) ? Math.floor(left / 60) + ' h ' : '') + (left % 60) + ' min';
      var tplCdTomorrow = (block.dataset.tplCdTomorrow || '').trim();
      var tplOn = (block.dataset.tplOn || '').trim();
      var html = null;
      if (shipDate.getTime() === today.getTime()){
        // Countdown to today's cutoff (ship_today when ship_cd_today is blank).
        short = block.dataset.shortToday || '';
        html = fill((block.dataset.tplCdToday || '').trim() || block.dataset.tplToday, { time: time });
        oneLine = false;
      } else if (isTomorrow && left <= 1440){
        // Under 24 hours to tomorrow's cutoff.
        short = block.dataset.shortTomorrow || '';
        if (tplCdTomorrow){ html = fill(tplCdTomorrow, { time: time }); oneLine = false; }
      } else if (tplOn){
        html = fill(tplOn, { date: fmtRange.format(shipDate) });
      }
      if (html === null){
        // Blank ship_cd_tomorrow / ship_on: the two-line ship_next form.
        html = fill(block.dataset.tplNext, {
          day: isTomorrow && tomorrowWord ? tomorrowWord : fmtDay.format(shipDate),
          date: fmtDate.format(shipDate)
        }, ['date']);
        oneLine = false;
      }
      if (shipEl) shipEl.innerHTML = html;
      if (!isNaN(tLow)){ start = addShipDays(shipDate, tLow); end = addShipDays(shipDate, tHigh); }
    } else if (!isNaN(tLow)){
      // Not same-day: ships in sLow–sHigh business days, then transit.
      start = addShipDays(today, sLow + tLow);
      end = addShipDays(today, sHigh + tHigh);
    }

    function rangeIn(fmt){ return start.getTime() === end.getTime() ? fmt.format(start) : fmt.format(start) + ' – ' + fmt.format(end); }
    var dated = !!(start && end && tplArrives);
    if (oneLine){
      if (arriveEl) arriveEl.hidden = true;
      if (tailEl && tailText && dated){
        tailText.innerHTML = fill(tplArrives, { range: rangeIn(fmtDate) });
        tailEl.removeAttribute('data-avail-wrap');
        tailEl.hidden = false;
      } else if (tailEl && !freight){
        tailEl.hidden = true;
      }
      // Freight without dates keeps its server-rendered freight note.
    } else {
      if (tailEl) tailEl.hidden = true;
      if (arriveEl){
        if (dated) arriveEl.innerHTML = fill(tplArrives, { range: rangeIn(fmtRange) });
        arriveEl.hidden = !dated;
      }
    }

    if (block.dataset.shipShort !== short){
      block.dataset.shipShort = short;
      document.dispatchEvent(new CustomEvent('cfs:ship-change', { detail: { short: short } }));
    }
  }

  function run(){ for (var i = 0; i < blocks.length; i++) update(blocks[i]); }
  run();
  // The countdown is in minutes: refresh every minute, aligned to the clock.
  window.setTimeout(function(){ run(); window.setInterval(run, 60000); }, (60 - new Date().getSeconds()) * 1000);
})();

/* ===== Made-to-order date (product-hero-stock-shipping lead-time branch): fills [data-lead-date] with today in the
   store timezone (data-tz) + data-lead-days calendar days, moved off Sat/Sun to the Monday, e.g. "Fri, Nov 13";
   or (café tier branch) + data-lead-bdays business days, counting Mon–Fri only.
   The sticky bar's text is already server-rendered; cfs:ship-change just makes it re-render once. ===== */
(function(){
  var blocks = document.querySelectorAll('.avail-block[data-lead-days], .avail-block[data-lead-bdays]');
  if (!blocks.length) return;

  var fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' });

  // Today's store date as a UTC midnight (same approach as nowIn() in Delivery lines); shopper's date if tz is unusable.
  function todayIn(tz){
    var out = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach(function(p){ out[p.type] = parseInt(p.value, 10); });
    } catch (e) {}
    if (!out.year){ var n = new Date(); out = { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate() }; }
    return new Date(Date.UTC(out.year, out.month - 1, out.day));
  }

  for (var i = 0; i < blocks.length; i++){
    var block = blocks[i];
    var el = block.querySelector('[data-lead-date]');
    var business = block.dataset.leadBdays != null;
    var days = parseInt(business ? block.dataset.leadBdays : block.dataset.leadDays, 10);
    if (!el || isNaN(days)) continue;
    var d = todayIn((block.dataset.tz || '').trim() || undefined);
    if (business){
      // Step one day at a time, counting only Mon–Fri
      while (days > 0){
        d.setUTCDate(d.getUTCDate() + 1);
        var bd = d.getUTCDay();
        if (bd !== 0 && bd !== 6) days--;
      }
    } else {
      d.setUTCDate(d.getUTCDate() + days);
      var wd = d.getUTCDay();
      if (wd === 6) d.setUTCDate(d.getUTCDate() + 2);
      else if (wd === 0) d.setUTCDate(d.getUTCDate() + 1);
    }
    el.textContent = fmt.format(d);
  }
  document.dispatchEvent(new CustomEvent('cfs:ship-change', { detail: { short: blocks[0].dataset.shipShort || '' } }));
})();

/* ===== Café site-check drawer (product-cafe-hook): opens from .hk-link, closes on ×, overlay and Escape, keeps focus
   inside while open and returns it to the trigger, locks page scroll (html.cafe-plan-open). Opens itself after a
   contact-form post (success or errors: [data-cafe-posted]) so the visitor sees the result. ===== */
(function(){
  var ov = document.querySelector('[data-cafe-ov]');
  if (!ov) return;
  var dialog = ov.querySelector('[role="dialog"]');
  var trigger = document.querySelector('[data-cafe-open]');
  var lastFocus = null;

  /* Out of the buy box column, so no ancestor stacking context can put it under the header or sticky bar. */
  document.body.appendChild(ov);

  function focusables(){
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
      function(el){ return el.offsetParent !== null; }
    );
  }
  function open(from, focusEl){
    lastFocus = from || null;
    ov.hidden = false;
    document.documentElement.classList.add('cafe-plan-open');
    var target = focusEl || dialog.querySelector('input:not([type="hidden"])') || focusables()[0];
    if (target) target.focus();
  }
  function close(){
    if (ov.hidden) return;
    ov.hidden = true;
    document.documentElement.classList.remove('cafe-plan-open');
    if (lastFocus) lastFocus.focus();
  }

  document.querySelectorAll('[data-cafe-open]').forEach(function(btn){
    btn.addEventListener('click', function(){ open(btn); });
  });
  ov.addEventListener('click', function(e){
    if (e.target === ov || e.target.closest('[data-cafe-close]')) close();
  });
  document.addEventListener('keydown', function(e){
    if (ov.hidden) return;
    if (e.key === 'Escape'){ e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))){ e.preventDefault(); first.focus(); }
  });

  var posted = dialog.querySelector('[data-cafe-posted]');
  if (posted || window.location.hash === '#CafeSiteCheck') open(trigger, posted);
})();

/* ===== Café install row (product-hero-cta): its out-of-area chat button ([data-bb-loc] [data-open-chat], added by
   the location block below) opens Tidio through window.openTidio('cafe', { models }) (assets/footer.js, whose own
   [data-open-chat] wiring only covers the launcher); models = [data-bb-loc]'s data-chat-model (product-hero-cta).
   Does nothing if it isn't there. ===== */
document.addEventListener('click', function(e){
  var btn = e.target.closest && e.target.closest('[data-bb-loc] [data-open-chat]');
  if (btn && typeof window.openTidio === 'function') window.openTidio('cafe', { models: btn.getAttribute('data-chat-model') || '' });
});

/* ===== "Still deciding?" chips (snippets/product-ask.liquid): a tap opens the chat with the chip's question, the same
   way as a pop-up teaser answer: window.openChatQuestion(block data-title, data-say, data-from) (assets/footer.js;
   Sam off-hours, Tidio in hours), else window.openTidio(). The chip shows .is-busy for 3 s or until the next tap. ===== */
(function(){
  var busy = null, busyTimer = null;
  function clearBusy(){
    if (busyTimer) { clearTimeout(busyTimer); busyTimer = null; }
    if (busy) { busy.classList.remove('is-busy'); busy = null; }
  }
  document.addEventListener('click', function(e){
    var chip = e.target.closest && e.target.closest('[data-pask-q]');
    if (!chip) return;
    var block = chip.closest('[data-pask]');
    clearBusy();
    busy = chip;
    chip.classList.add('is-busy');
    busyTimer = setTimeout(clearBusy, 3000);
    if (typeof window.openChatQuestion === 'function') {
      window.openChatQuestion(block ? block.getAttribute('data-title') || '' : '', chip.getAttribute('data-say') || '', chip.getAttribute('data-from') || '');
    } else if (typeof window.openTidio === 'function') {
      window.openTidio();
    }
  });
})();

/* ===== Café install row location (product-hero-cta [data-bb-loc]): after load, names the visitor's lower-48 city in
   the install line (data-tpl-near, "{place}" → bold City, ST) with a Change link that opens a ZIP field.
   Order: localStorage cfs_loc (under 30 days) → free.freeipapi.com → ipapi.co; ZIP via api.zippopotam.us.
   Every call has a 2.5 s timeout and a catch; an IP answer outside the lower 48 + DC, or no answer, keeps the
   server-rendered install_sub line. A ZIP shows "checking" (data-tpl-checking, at least 800 ms), then a confirmed
   result: covered (tick + data-tpl-covered), out of area (AK, HI, territories: data-tpl-out + a chat button),
   not found (field reopens, data-tpl-not-found in [data-loc-msg]) or lookup failed (data-tpl-offline).
   The tick shows only right after a ZIP check; on load a saved ZIP uses the plain near line (City, ST ZIP).
   Copy comes from the markup; only the state/territory tables live here. ===== */
(function(){
  var box = document.querySelector('[data-bb-loc]');
  if (!box) return;
  var line = box.querySelector('[data-loc-line]');
  var chg = box.querySelector('[data-loc-chg]');
  var ask = box.querySelector('[data-loc-ask]');
  var openBtn = box.querySelector('[data-loc-open]');
  var input = box.querySelector('.bb-loc__zip');
  var submit = box.querySelector('[data-loc-submit]');
  var msg = box.querySelector('[data-loc-msg]');
  var tpl = box.getAttribute('data-tpl-near') || '';
  if (!line || !chg || !ask || !openBtn || !input || !submit || tpl.indexOf('{place}') === -1) return;
  function t(name){ return box.getAttribute('data-tpl-' + name) || ''; }

  var fallback = line.textContent;
  var KEY = 'cfs_loc', MAX_AGE = 30 * 864e5, TIMEOUT = 2500;

  // Lower 48 + DC (no AK, HI, PR or other territories): code → name
  var STATES = {
    AL:'Alabama', AZ:'Arizona', AR:'Arkansas', CA:'California', CO:'Colorado', CT:'Connecticut', DE:'Delaware',
    DC:'District of Columbia', FL:'Florida', GA:'Georgia', ID:'Idaho', IL:'Illinois', IN:'Indiana', IA:'Iowa',
    KS:'Kansas', KY:'Kentucky', LA:'Louisiana', ME:'Maine', MD:'Maryland', MA:'Massachusetts', MI:'Michigan',
    MN:'Minnesota', MS:'Mississippi', MO:'Missouri', MT:'Montana', NE:'Nebraska', NV:'Nevada', NH:'New Hampshire',
    NJ:'New Jersey', NM:'New Mexico', NY:'New York', NC:'North Carolina', ND:'North Dakota', OH:'Ohio',
    OK:'Oklahoma', OR:'Oregon', PA:'Pennsylvania', RI:'Rhode Island', SC:'South Carolina', SD:'South Dakota',
    TN:'Tennessee', TX:'Texas', UT:'Utah', VT:'Vermont', VA:'Virginia', WA:'Washington', WV:'West Virginia',
    WI:'Wisconsin', WY:'Wyoming'
  };
  // Outside the install area: code → name as it reads after "in"
  var OUT = {
    AK:'Alaska', HI:'Hawaii', PR:'Puerto Rico', GU:'Guam', VI:'the U.S. Virgin Islands', AS:'American Samoa',
    MP:'the Northern Mariana Islands'
  };
  var TICK = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var BY_NAME = { 'washington, d.c.': 'DC', 'washington dc': 'DC' };
  Object.keys(STATES).forEach(function(k){ BY_NAME[STATES[k].toLowerCase()] = k; });

  // A 2-letter code or full name → lower-48 code, else ''
  function stateCode(v){
    v = String(v == null ? '' : v).trim();
    if (!v) return '';
    if (STATES.hasOwnProperty(v.toUpperCase())) return v.toUpperCase();
    return BY_NAME[v.toLowerCase()] || '';
  }
  function esc(s){
    return String(s).replace(/[&<>"']/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; });
  }
  // Escaped template with {key} replaced by html (already safe)
  function fill(text, key, html){ return text.split('{' + key + '}').map(esc).join(html); }
  function render(place){
    line.innerHTML = fill(tpl, 'place', '<b>' + esc(place) + '</b>');
    chg.hidden = false;
  }
  // ZIP just checked in this page view, lower 48: green tick + loc_covered up to {place}, then the bold place
  function renderCovered(place){
    var cov = t('covered'), i = cov.indexOf('{place}');
    if (i === -1) { render(place); return; }
    var pre = cov.slice(0, i);
    line.innerHTML = '<span class="bb-loc__cov">' + TICK + esc(pre.trim()) + '</span>' + (/\s$/.test(pre) ? ' ' : '') +
      '<b>' + esc(place) + '</b>' + fill(cov.slice(i + 7), 'place', '<b>' + esc(place) + '</b>');
    chg.hidden = false;
  }
  // AK, HI or a territory: loc_out + a chat button (opened by the café chat click handler above)
  function renderOut(st){
    var out = t('out'), link = t('out-link'), model = box.getAttribute('data-chat-model') || '';
    line.innerHTML = out ? fill(out, 'state', esc(OUT[st])) : esc(fallback);
    if (out && link) line.innerHTML += ' <button type="button" class="bb-loc__btn" data-open-chat' +
      (model ? ' data-chat-model="' + esc(model) + '"' : '') + '>' + esc(link) + '</button>';
    chg.hidden = false;
  }
  // Cached entry on load: out of area keeps its line; a saved ZIP or IP city gets the plain near line (no tick)
  function renderLoc(loc){
    if (loc.out) renderOut(loc.state);
    else render(placeOf(loc));
  }
  function placeOf(loc){ return loc.city + ', ' + loc.state + (loc.src === 'zip' && loc.zip ? ' ' + loc.zip : ''); }

  function readCache(){
    try {
      var c = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (!c || typeof c.ts !== 'number' || Date.now() - c.ts >= MAX_AGE || Date.now() < c.ts) return null;
      if (c.out === true) {
        if (c.src === 'zip' && OUT.hasOwnProperty(c.state) && /^\d{5}$/.test(c.zip)) return c;
      } else if (typeof c.city === 'string' && c.city && stateCode(c.state) === c.state && (c.src === 'ip' || c.src === 'zip')) return c;
    } catch (e) {}
    return null;
  }
  function writeCache(loc){
    var c = loc.out ? { state: loc.state, zip: loc.zip, src: 'zip', out: true, ts: Date.now() }
                    : { city: loc.city, state: loc.state, zip: loc.zip || '', src: loc.src, ts: Date.now() };
    try { window.localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
  }

  // fetch → JSON with a 2.5 s timeout; rejects with err.status on a non-2xx answer
  function getJSON(url){
    return new Promise(function(resolve, reject){
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = setTimeout(function(){ if (ctrl) ctrl.abort(); reject(new Error('timeout')); }, TIMEOUT);
      fetch(url, { cache: 'no-store', credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
        .then(function(r){
          if (!r.ok) { var err = new Error('http ' + r.status); err.status = r.status; throw err; }
          return r.json();
        })
        .then(function(d){ clearTimeout(timer); resolve(d); }, function(e){ clearTimeout(timer); reject(e); });
    });
  }

  // IP answer → {city, state, zip} in the lower 48, null if outside it; throws if the answer is unusable
  function fromIp(country, region, city, zip){
    if (!country) throw new Error('no country');
    if (String(country).toUpperCase() !== 'US') return null;
    var st = stateCode(region);
    city = String(city || '').trim();
    return st && city ? { city: city, state: st, zip: String(zip || '').trim(), src: 'ip' } : null;
  }
  function detect(){
    return getJSON('https://free.freeipapi.com/api/json')
      .then(function(d){ return fromIp(d && d.countryCode, d && d.regionName, d && d.cityName, d && d.zipCode); })
      .catch(function(){
        return getJSON('https://ipapi.co/json/').then(function(d){
          if (!d || d.error) throw new Error('ipapi');
          return fromIp(d.country_code, d.region_code || d.region, d.city, d.postal);
        });
      })
      .then(function(loc){ if (loc) { render(placeOf(loc)); writeCache(loc); } })
      .catch(function(){});
  }

  function setAsk(open){
    ask.hidden = !open;
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) input.focus();
  }
  // Message under the field (empty text → hidden)
  function setMsg(text){
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
  }
  function invalid(text){
    input.setAttribute('aria-invalid', 'true');
    setMsg(text);
    input.focus();
  }
  openBtn.addEventListener('click', function(){ setAsk(ask.hidden); });
  input.addEventListener('input', function(){ input.removeAttribute('aria-invalid'); setMsg(''); });

  // ZIP → {kind: 'ok' | 'out' | 'nf' | 'off', city, state}
  function zipLookup(zip){
    return getJSON('https://api.zippopotam.us/us/' + zip).then(function(d){
      var p = d && d.places && d.places[0];
      if (!p) return { kind: 'nf' };
      var raw = String(p['state abbreviation'] || '').trim().toUpperCase();
      var st = stateCode(raw), city = String(p['place name'] || '').trim();
      if (st && city) return { kind: 'ok', city: city, state: st };
      if (OUT.hasOwnProperty(raw)) return { kind: 'out', state: raw };
      return { kind: 'off' }; // a place we can't classify (e.g. military mail codes): confirm by hand
    }, function(e){
      return { kind: e && e.status === 404 ? 'nf' : 'off' };
    });
  }

  var busy = false;
  function lookupZip(){
    if (busy) return;
    var zip = (input.value || '').trim();
    if (!/^\d{5}$/.test(zip)) { invalid(t('invalid')); return; }
    busy = true;
    input.removeAttribute('aria-invalid');
    setMsg('');
    var before = line.innerHTML;
    setAsk(false);
    openBtn.focus();
    line.innerHTML = '<span class="bb-loc__chk"><i class="bb-loc__spin" aria-hidden="true"></i>' +
      fill(t('checking'), 'zip', esc(zip)) + '</span>';
    var wait = new Promise(function(resolve){ setTimeout(resolve, 800); });
    Promise.all([zipLookup(zip), wait])
      .then(function(a){
        var res = a[0];
        if (res.kind === 'ok') {
          var loc = { city: res.city, state: res.state, zip: zip, src: 'zip' };
          renderCovered(placeOf(loc));
          writeCache(loc);
        } else if (res.kind === 'out') {
          renderOut(res.state);
          writeCache({ state: res.state, zip: zip, out: true });
        } else if (res.kind === 'nf') {
          line.innerHTML = before;
          setAsk(true);
          invalid(t('not-found').split('{zip}').join(zip)); // plain text (textContent)
        } else {
          var off = t('offline');
          if (off) { line.innerHTML = fill(off, 'zip', '<b>' + esc(zip) + '</b>'); chg.hidden = false; }
          else render(zip);
        }
      })
      .catch(function(){ line.innerHTML = before; })
      .then(function(){ busy = false; });
  }
  submit.addEventListener('click', lookupZip);
  input.addEventListener('keydown', function(e){
    if (e.key === 'Enter') { e.preventDefault(); lookupZip(); }
  });

  function start(){
    var cached = readCache();
    if (cached) renderLoc(cached);
    else detect();
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();

/* ===== Buy it as a set (product-sets): dataLayer pd_set_view / pd_set_click ===== */
(() => {
  const root = document.querySelector('[data-pset]');
  if (!root) return;
  const push = (data) => { if (window.dataLayer) window.dataLayer.push(data); };

  // Block seen: once, when half of it is in view
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      push({ event: 'pd_set_view', set_count: Number(root.dataset.psetCount) });
    }, { threshold: 0.5 });
    io.observe(root);
  }

  // Row links navigate as normal; the push never delays them
  root.addEventListener('click', (e) => {
    const row = e.target.closest('.pset__row');
    if (!row) return;
    push({ event: 'pd_set_click', set_handle: row.dataset.psetHandle, set_position: Number(row.dataset.psetPosition) });
  });
})();

/* ===== About the model (product-about): desktop always open with Read more / Show less; phone collapsed accordion row ===== */
(function(){
  var acc = document.getElementById('pd-about');
  if (!acc) return;
  var sum  = acc.querySelector('.pa-sum');
  var body = document.getElementById('pa-body');
  var btn  = acc.querySelector('.pa-more');
  var mq   = window.matchMedia('(max-width: 768px)');

  function applyMode(){
    if (mq.matches){ acc.open = false; sum.removeAttribute('tabindex'); }
    else { acc.open = true; sum.setAttribute('tabindex', '-1'); }
    checkOverflow();
  }
  function checkOverflow(){
    if (mq.matches){ btn.hidden = true; return; }
    if (!body.classList.contains('is-clamped')) return;
    btn.hidden = !(body.scrollHeight > body.clientHeight + 1);
  }

  sum.addEventListener('click', function(e){ if (!mq.matches) e.preventDefault(); });
  btn.addEventListener('click', function(){
    var expand = body.classList.contains('is-clamped');
    body.classList.toggle('is-clamped', !expand);
    btn.textContent = expand ? btn.dataset.less : btn.dataset.more;
    btn.setAttribute('aria-expanded', expand ? 'true' : 'false');
    if (!expand && acc.getBoundingClientRect().top < 0){
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      acc.scrollIntoView({ block: 'start', behavior: still ? 'auto' : 'smooth' });
    }
  });

  applyMode();
  if (mq.addEventListener) mq.addEventListener('change', applyMode);
  if (document.readyState === 'complete') checkOverflow();
  else window.addEventListener('load', checkOverflow);
})();

/* ===== ⓘ tooltips (buy box): a .bb-tipbtn with aria-controls pointing at its .bb-tip.
   Hover opens where (hover:hover) applies, click/tap toggles (and pins a hovered tip), keyboard focus opens,
   Esc closes and returns focus. A hover-opened tip closes 250ms after the pointer leaves both the button and the tip;
   coming back to either (or into the tip, which pins it) cancels that. Delegated on document, so tips inside markup
   swapped in later (the colour swatches replace .price-panel) keep working. ===== */
(function(){
  if (window.__cfsBuyBoxTips) return;
  window.__cfsBuyBoxTips = true;

  var hoverMQ = window.matchMedia('(hover: hover)');
  var open = null, mode = '', refocusing = false, closeTimer = null;
  var CLOSE_DELAY = 250;

  function cancelClose(){ clearTimeout(closeTimer); closeTimer = null; }
  /* Size the ::before bridge to the real gap: button bottom to tip top, wide enough to cover the button too. */
  function bridge(btn, tip){
    var b = btn.getBoundingClientRect(), t = tip.getBoundingClientRect();
    var top = t.top + tip.clientTop, left = t.left + tip.clientLeft, right = t.right - tip.clientLeft;
    tip.style.setProperty('--bb-tip-gap', Math.max(0, Math.ceil(top - b.bottom)) + 'px');
    tip.style.setProperty('--bb-tip-l', Math.min(0, Math.floor(b.left - left)) + 'px');
    tip.style.setProperty('--bb-tip-r', Math.min(0, Math.floor(right - b.right)) + 'px');
  }

  function tipOf(btn){ return document.getElementById(btn.getAttribute('aria-controls')); }
  function inside(node, btn){
    if (!node || !btn) return false;
    var tip = tipOf(btn);
    return btn.contains(node) || (!!tip && tip.contains(node));
  }
  function set(btn, show, how){
    var tip = tipOf(btn);
    if (!tip) return;
    if (show && open && open !== btn) set(open, false);
    cancelClose();
    tip.hidden = !show;
    btn.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (show){ open = btn; mode = how; bridge(btn, tip); }
    else if (open === btn){ open = null; mode = ''; }
  }
  function isFocusVisible(el){
    try { return el.matches(':focus-visible'); } catch (e) { return false; }
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.bb-tipbtn');
    if (btn){
      if (open === btn && mode !== 'click'){ cancelClose(); mode = 'click'; return; }
      set(btn, open !== btn, 'click');
      return;
    }
    if (open && !inside(e.target, open)) set(open, false);
  });

  document.addEventListener('mouseover', function(e){
    if (!hoverMQ.matches) return;
    var btn = e.target.closest && e.target.closest('.bb-tipbtn');
    if (btn && open !== btn){ set(btn, true, 'hover'); return; }
    /* Back on the button or inside the tip (pins it): cancel a pending close. */
    if (open && mode === 'hover' && inside(e.target, open)) cancelClose();
  });
  document.addEventListener('mouseout', function(e){
    if (!hoverMQ.matches || !open || mode !== 'hover') return;
    if (inside(e.target, open) && !inside(e.relatedTarget, open)){
      var btn = open;
      cancelClose();
      closeTimer = setTimeout(function(){
        closeTimer = null;
        if (open === btn && mode === 'hover') set(btn, false);
      }, CLOSE_DELAY);
    }
  });

  document.addEventListener('focusin', function(e){
    if (refocusing) return;
    var btn = e.target.closest && e.target.closest('.bb-tipbtn');
    if (btn && open !== btn && isFocusVisible(btn)){ set(btn, true, 'focus'); return; }
    if (open && !inside(e.target, open)) set(open, false);
  });

  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape' || !open) return;
    var btn = open;
    set(btn, false);
    refocusing = true;
    btn.focus();
    refocusing = false;
  });
})();

/* ===== Product details (product-details): phone accordions, reviews link, smooth jumps, scroll spy ===== */
(function(){
  var root = document.getElementById('pd');
  if (!root) return;
  var nav  = root.querySelector('.pd-jump');
  var secs = Array.prototype.slice.call(root.querySelectorAll('.pd-sec'));
  var mq   = window.matchMedia('(max-width: 768px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Desktop: sections always open, summaries are plain headings. Phone: collapsed accordion rows. */
  function applyMode(){
    secs.forEach(function(sec){
      var sum = sec.querySelector('.pd-sum');
      if (mq.matches){ sec.open = false; sum.removeAttribute('tabindex'); }
      else { sec.open = true; sum.setAttribute('tabindex', '-1'); }
    });
  }
  applyMode();
  if (mq.addEventListener) mq.addEventListener('change', applyMode);
  root.addEventListener('click', function(e){
    if (!mq.matches && e.target.closest && e.target.closest('.pd-sum')) e.preventDefault();
  });

  /* Reviews link: only when the Judge.me review widget is on this page. Judge.me can render
     late, so look again at load and once more 3 s after. */
  var revLink = nav && nav.querySelector('[data-pd-rev]');
  function findRev(){
    return document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
  }
  function showRev(rev){
    if (!revLink.hidden) return;
    if (!rev.id) rev.id = 'pd-reviews';
    rev.style.scrollMarginTop = 'calc(var(--hdr-compact-h, 0px) + 16px)';
    revLink.setAttribute('href', '#' + rev.id);
    revLink.hidden = false;
    /* Found late: hand the widget to the scroll spy below, which has already started. */
    var i = links ? links.indexOf(revLink) : -1;
    if (i > -1){
      targets[i] = rev;
      if (io) io.observe(rev);
      update();
    }
  }
  if (revLink){
    var checkRev = function(){ var found = findRev(); if (found) showRev(found); };
    var lateRev = function(){ checkRev(); setTimeout(checkRev, 3000); };
    if (document.readyState === 'complete') lateRev();
    else window.addEventListener('load', lateRev, { once: true });
  }

  /* Smooth jump (instant with reduced motion) for the jump bar and "See all specs". */
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href^="#pd-"], .pd-jump a');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    if (target.tagName === 'DETAILS') target.open = true;
    target.scrollIntoView({ block: 'start', behavior: still.matches ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
    if (nav && nav.contains(a)) setActive(a);
  });

  /* Active link follows the scroll. */
  if (!nav) return;
  var links = Array.prototype.slice.call(nav.querySelectorAll('a'));
  var targets = links.map(function(a){ return document.getElementById(a.getAttribute('href').slice(1)); });
  function setActive(link){
    links.forEach(function(a){
      var on = a === link;
      a.classList.toggle('is-on', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  function update(){
    var line = window.innerHeight * 0.3, pick = 0;
    targets.forEach(function(t, i){
      if (t && !links[i].hidden && t.getBoundingClientRect().top <= line) pick = i;
    });
    setActive(links[pick]);
  }
  update();
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(update, { rootMargin: '0px 0px -70% 0px', threshold: [0, 1] });
    targets.forEach(function(t, i){ if (t && !links[i].hidden) io.observe(t); });
  }
})();

/* ===== "Email me all documents" (product-details): opens once per session on the first download-card click
   (the PDF still opens in its new tab), sends a Klaviyo list subscription and a "Requested Product Documents" event.
   Stores nothing personal. Strings come from the panel's data-* attributes. ===== */
(function(){
  var panel = document.querySelector('[data-pd-mail]');
  if (!panel) return;
  var KEY = 'cfs:docmail:shown';
  var form  = panel.querySelector('[data-pd-mail-form]');
  var input = panel.querySelector('input[type="email"]');
  var btn   = form.querySelector('button[type="submit"]');
  var err   = panel.querySelector('[data-pd-mail-err]');
  var ok    = panel.querySelector('[data-pd-mail-ok]');
  var btnLabel = btn.textContent;
  var lastCard = null, closeTimer = null;

  /* Out of the phone accordion (a closed <details> hides it) and any transformed ancestor. */
  document.body.appendChild(panel);

  function shown(){ try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function markShown(){ try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function track(name){ if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: name }); }

  function openPanel(card){
    lastCard = card;
    markShown();
    panel.hidden = false;
    document.documentElement.classList.add('pd-mail-open');
    input.focus();
    track('pd_docs_email_open');
  }
  function closePanel(){
    if (panel.hidden) return;
    clearTimeout(closeTimer);
    var hadFocus = panel.contains(document.activeElement);
    panel.hidden = true;
    document.documentElement.classList.remove('pd-mail-open');
    if (hadFocus && lastCard) lastCard.focus();
  }

  document.addEventListener('click', function(e){
    var card = e.target.closest && e.target.closest('.pd-doc');
    if (!card || !panel.hidden || shown()) return;
    openPanel(card);
  });
  panel.querySelector('[data-pd-mail-close]').addEventListener('click', closePanel);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && !panel.hidden) closePanel();
  });

  function docs(){
    return Array.prototype.map.call(document.querySelectorAll('#pd-docs .pd-doc'), function(a){
      var note = a.querySelector('.pd-doc__t span');
      return { label: a.getAttribute('data-doc-label') || '', note: note ? note.textContent.trim() : '', url: a.href };
    });
  }
  function post(path, body){
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(panel.dataset.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function(r){ if (!r.ok) throw new Error(r.status); });
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var email = input.value.trim();
    err.textContent = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
      err.textContent = panel.dataset.errInvalid || '';
      input.focus();
      return;
    }
    btn.disabled = true;
    btn.textContent = panel.dataset.sending || btnLabel;

    var profile = { data: { type: 'profile', attributes: { email: email } } };
    var list = docs();
    Promise.all([
      post('subscriptions', { data: { type: 'subscription',
        attributes: { profile: profile, custom_source: 'Product documents' },
        relationships: { list: { data: { type: 'list', id: panel.dataset.list } } } } }),
      post('events', { data: { type: 'event', attributes: {
        properties: { product_title: panel.dataset.model, product_url: panel.dataset.url, product_image: panel.dataset.img, doc_count: list.length, docs: list },
        metric: { data: { type: 'metric', attributes: { name: panel.dataset.metric } } },
        profile: profile } } })
    ]).then(function(){
      ok.textContent = (panel.dataset.success || '').replace('{email}', email);
      form.hidden = true;
      ok.hidden = false;
      ok.focus();
      track('pd_docs_email_submit');
      closeTimer = setTimeout(closePanel, 4000);
    }).catch(function(){
      err.textContent = panel.dataset.errSend || '';
      btn.disabled = false;
      btn.textContent = btnLabel;
    });
  });
})();

/* ===== Sticky add-to-cart bar (sticky-atc): show/hide, Tidio offset, price/colour/status sync, add to cart ===== */
(() => {
  const sticky = document.getElementById('stickyATC');
  if (!sticky) return;

  const sourceRow = document.querySelector('.atc-row');
  if (!sourceRow) return;

  const DESKTOP_BP = 1025;

  function isDesktop(){ return window.innerWidth >= DESKTOP_BP; }

  // Desktop: show when the main ATC is fully above the viewport.
  // Mobile: show whenever the main ATC is out of view, below or above the
  // screen (so it's showing on landing, where the ATC starts below the fold).
  function computeShow(){
    const r = sourceRow.getBoundingClientRect();
    if (isDesktop()) return r.bottom <= 0;
    const atcInView = r.bottom > 0 && r.top < window.innerHeight;
    return !atcInView;
  }

  // ---------- Tidio launcher offset (moves it above this bar when it's showing) ----------
  // tidioChatApi.adjustStyles() only takes effect the first time per page load, so it's called
  // ONCE to wire #tidio's bottom to the --tidio-bottom custom property, which is then updated
  // directly on every show/hide.
  const TIDIO_GAP = 6;                // gap between the top of this bar and the launcher
  const TIDIO_DEFAULT_BOTTOM = 10;    // resting offset when the bar is hidden
  const TIDIO_TRANSITION = 'bottom .28s ease'; // matches this bar's own show/hide transition
  let tidioReady = false;
  let barVisible = false;

  function setTidioBottomVar(px){
    document.documentElement.style.setProperty('--tidio-bottom', px + 'px');
  }

  // Recomputes the correct offset from the CURRENT bar state.
  function syncTidioOffset(){
    if (barVisible){
      setTidioBottomVar(Math.ceil(sticky.getBoundingClientRect().height) + TIDIO_GAP);
    } else {
      setTidioBottomVar(TIDIO_DEFAULT_BOTTOM);
    }
  }

  function onTidioChatApiReady(){
    tidioReady = true;
    // One-time setup: tie #tidio's position to the CSS variable.
    window.tidioChatApi.adjustStyles(`#tidio { bottom: var(--tidio-bottom, ${TIDIO_DEFAULT_BOTTOM}px) !important; transition: ${TIDIO_TRANSITION} !important; }`);
    syncTidioOffset();
  }
  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', onTidioChatApiReady);
  } else {
    document.addEventListener('tidioChat-ready', onTidioChatApiReady);
  }

  // will-change only for the 280ms show/hide transition: .is-animating, removed on transitionend (timer as a fallback).
  let animTimer = null;
  function endAnimating(){
    clearTimeout(animTimer);
    animTimer = null;
    sticky.classList.remove('is-animating');
  }
  sticky.addEventListener('transitionend', (e) => {
    if (e.target === sticky) endAnimating();
  });

  // The first evaluation lands in its final state with no slide-in; the
  // transition only runs for later show/hide changes.
  let firstEval = true;

  function setVisibility(show){
    if (firstEval){
      firstEval = false;
      sticky.style.transition = 'none';
      sticky.classList.toggle('is-visible', show);
      void sticky.offsetHeight; // commit the start state before restoring the transition
      sticky.style.transition = '';
    } else if (sticky.classList.contains('is-visible') !== show) {
      sticky.classList.add('is-animating');
      clearTimeout(animTimer);
      animTimer = setTimeout(endAnimating, 400);
      sticky.classList.toggle('is-visible', show);
    }
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    barVisible = show;

    // Always keep the variable current: chat-launcher.liquid reads it
    // whether or not Tidio has loaded (Tidio's window picks it up once
    // the adjustStyles rule above exists).
    syncTidioOffset();
  }
  syncTidioOffset();

  function reevaluate(){ setVisibility(computeShow()); }

  // One observer on the main .atc-row.
  const io = new IntersectionObserver(reevaluate, { root: null, threshold: [0] });
  io.observe(sourceRow);

  window.addEventListener('resize', reevaluate, { passive: true });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) reevaluate(); });

  // ---------- Price, colour and status line ----------
  const priceEl = sticky.querySelector('[data-sa-price]');
  const statusEl = sticky.querySelector('[data-sa-status]');
  const appliedTpl = sticky.dataset.appliedTpl || '';
  const promoRoot = document.querySelector('[data-promo-root]');
  let promo = {
    applied: !!(promoRoot && promoRoot.classList.contains('is-applied')),
    badge: promoRoot ? (promoRoot.dataset.badgeText || '') : ''
  };

  function syncPrice(){
    const src = document.querySelector('.price-panel .sale, .price-panel .sale-show');
    if (src && priceEl) priceEl.innerHTML = src.innerHTML;
  }

  function sentenceCase(s){
    s = String(s || '').trim().toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function addSpan(cls, text, dot){
    const el = document.createElement('span');
    el.className = cls;
    if (dot) el.appendChild(document.createElement('i'));
    el.appendChild(document.createTextNode(text));
    statusEl.appendChild(el);
  }

  function renderStatus(){
    if (!statusEl) return;
    statusEl.textContent = '';
    if (promo.applied && promo.badge && appliedTpl){
      addSpan('sa-ok', '✓ ' + appliedTpl.split('{badge}').join(sentenceCase(promo.badge)));
      return;
    }
    const ab = document.querySelector('.avail-block');
    const short = ab ? (ab.dataset.shipShort || '') : '';
    const label = ab ? (ab.dataset.shipLabel || '') : '';
    if (short){
      addSpan('sa-ok', short, true);
      if (label) addSpan('sa-mu', ' · ' + label);
    } else if (label){
      addSpan('sa-mu', label);
    }
  }

  document.addEventListener('cfs:promo-change', (e) => {
    const d = e.detail || {};
    promo = { applied: !!d.applied, badge: d.badge || promo.badge };
    renderStatus();
  });
  document.addEventListener('cfs:ship-change', renderStatus);

  // Colour changed in place (product-hero-color-swatches): the price
  // panel was replaced, so refresh price + colour line.
  document.addEventListener('variant:change', () => {
    syncPrice();
    const sel = document.querySelector('[data-cswatch-selected]');
    const colorVal = sticky.querySelector('.mini-variant-line[data-role="color"] .mini-variant-value');
    if (sel && colorVal) colorVal.textContent = sel.textContent;
    reevaluate();
  });

  syncPrice();
  renderStatus();

  // Keep the "setup" mini-variant line in sync with any component that
  // dispatches setup-property-change when its staged value changes.
  document.addEventListener('setup-property-change', (e) => {
    const val = (e.detail && e.detail.value) || '';
    if (!val) return;
    const valueEl = sticky.querySelector('.mini-variant-line[data-role="setup"] .mini-variant-value');
    if (valueEl) valueEl.textContent = val;
  });

  // Sticky Add to Cart
  const stickyBtn = sticky.querySelector('[data-add-to-checkout]');
  stickyBtn?.addEventListener('click', (ev) => {
    ev.preventDefault();
    if (stickyBtn.disabled) return;

    const mainBtn = document.querySelector('.sticky-buy-box [data-add-to-checkout]');
    if (mainBtn){ mainBtn.click(); return; }
  }, { passive:false });

  // Initial state
  reevaluate();
})();

/* ===== Pop-up offer (product-popup-offer): opens data-delay seconds after load, or earlier on exit intent when
   data-exit-intent is set (café pages); waits while another overlay is open;
   four server-rendered steps swapped with [hidden], Klaviyo email/SMS subscription + unlock event, step 4 applies the
   code (window.CFS.cartCodes) and clicks the page's real add-to-cart. Stores only sessionStorage cfs:popup:dismissed
   and localStorage cfs:popup:done. Strings come from the root's data-* attributes and the markup. ===== */
(() => {
  const root = document.querySelector('[data-po]');
  if (!root) return;

  const DISMISSED = 'cfs:popup:dismissed';
  const DONE = 'cfs:popup:done';
  const OVERLAY_CLASSES = ['cg-lock', 'cafe-plan-open', 'pd-mail-open', 'menu-drawer-open', 'hdr-search-open', 'bt-dr-open', 'cmp-lock'];
  const DESKTOP_BP = 1025;
  const d = root.dataset;
  const html = document.documentElement;

  function getFlag(store, key) { try { return window[store].getItem(key) === '1'; } catch (e) { return false; } }
  function setFlag(store, key) { try { window[store].setItem(key, '1'); } catch (e) {} }
  if (getFlag('sessionStorage', DISMISSED) || getFlag('localStorage', DONE)) return;

  /* Out of any transformed ancestor so position:fixed is relative to the viewport. */
  document.body.appendChild(root);

  const box = root.querySelector('[data-po-box]');
  const bar = root.querySelector('[data-po-bar]');
  const fill = root.querySelector('[data-po-fill]');
  const steps = {};
  root.querySelectorAll('[data-po-step]').forEach((el) => { steps[el.dataset.poStep] = el; });
  const emailForm = root.querySelector('[data-po-email-form]');
  const emailInput = emailForm.querySelector('input[type="email"]');
  const emailErr = emailForm.querySelector('[data-po-err]');
  const emailBtn = emailForm.querySelector('button[type="submit"]');
  const phoneForm = root.querySelector('[data-po-phone-form]');
  const phoneInput = phoneForm.querySelector('input[type="tel"]');
  const phoneErr = phoneForm.querySelector('[data-po-err]');
  const phoneBtn = phoneForm.querySelector('button[type="submit"]');
  const atcBtn = root.querySelector('[data-po-atc]');
  const LABELLED_BY = { 1: 'po-t1 po-t1b', 2: 'po-t2', 3: 'po-t3', 4: 'po-t4' };
  const FOCUS_TARGET = { 2: emailInput, 3: phoneInput };

  let prices = {};
  try { prices = JSON.parse(root.querySelector('[data-po-prices]').textContent) || {}; } catch (e) {}
  let variantId = d.variant;
  let step = 1;
  let audience = '';
  let email = '';
  let lastFocus = null;

  // Each step event goes to dataLayer, GA4 (gtag) and Clarity, at most once per open. Never the email or phone.
  let fired = {};
  function track(name, extra) {
    if (fired[name]) return;
    fired[name] = true;
    const params = Object.assign({
      po_layout: window.innerWidth < DESKTOP_BP ? 'phone' : 'desktop',
      po_amount: Number(d.amount),
      po_product: d.product || '',
      po_brand: d.brand || ''
    }, extra);
    try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: name }, params)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }

  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(d.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then((r) => { if (!r.ok) throw new Error(r.status); });
  }

  function subscribe(attributes) {
    return post('subscriptions', { data: { type: 'subscription',
      attributes: { custom_source: 'Product pop-up', profile: { data: { type: 'profile', attributes } } },
      relationships: { list: { data: { type: 'list', id: d.list } } } } });
  }

  function currentPrices() { return prices[variantId] || ['', '']; }

  // Cart permalink for the emails: one of the current variant, straight to checkout with the code applied
  function cartUrl() {
    return d.shop + '/cart/' + variantId + ':1?discount=' + encodeURIComponent(d.code);
  }

  // ---------- Steps ----------
  function setStep(n) {
    step = n;
    Object.keys(steps).forEach((k) => { steps[k].hidden = Number(k) !== n; });
    box.setAttribute('aria-labelledby', LABELLED_BY[n]);

    fill.className = 'po__fill ' + (n === 1 ? 'po__fill--a' : n === 4 ? 'po__fill--full' : 'po__fill--b');
    bar.setAttribute('aria-valuenow', n === 1 ? '1' : '2');
    bar.setAttribute('aria-label', n === 1 ? d.step1 : d.step2);
    if (n === 4) bar.setAttribute('aria-hidden', 'true');

    if (n === 1) { box.focus(); return; }
    // Desktop: straight into the field. Phone: the title, so the keyboard doesn't cover the drawer before it's read.
    const field = FOCUS_TARGET[n];
    if (field && window.innerWidth >= DESKTOP_BP) field.focus();
    else steps[n].querySelector('[tabindex="-1"]')?.focus();
  }

  // ---------- Open / close ----------
  function otherOverlayOpen() {
    return OVERLAY_CLASSES.some((c) => html.classList.contains(c)) || !!document.querySelector('.cdf-drawer.is-open');
  }

  // Entrance/exit: .is-in drives the CSS transitions (transform/opacity only). Reduced motion skips the wait.
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let closing = false;

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    void root.offsetWidth; // commit the off-screen start state so the transition runs
    root.classList.add('is-in');
    html.classList.add('po-open');
    fired = {};
    setStep(1);
    track('po_open');
  }

  function tryOpen() {
    if (getFlag('sessionStorage', DISMISSED) || getFlag('localStorage', DONE)) return;
    if (otherOverlayOpen()) { setTimeout(tryOpen, 400); return; }
    open();
  }

  // Steps 1–2 close as "No thanks" (not again this visit); steps 3–4 already gave an email, so no flag.
  function close() {
    if (root.hidden || closing) return;
    if (step <= 2) {
      setFlag('sessionStorage', DISMISSED);
      track('po_dismiss', { po_step: step });
    }
    const hadFocus = root.contains(document.activeElement);
    closing = true;
    root.classList.remove('is-in');

    let timer = null;
    const finish = () => {
      if (!closing) return;
      closing = false;
      clearTimeout(timer);
      box.removeEventListener('transitionend', onEnd);
      // Not if something else (e.g. the cart drawer after step 4's add) took focus during the exit
      const stillOurs = root.contains(document.activeElement) || document.activeElement === document.body;
      root.hidden = true;
      html.classList.remove('po-open');
      if (hadFocus && stillOurs && lastFocus && lastFocus.focus) lastFocus.focus();
    };
    function onEnd(e) { if (e.target === box && e.propertyName === 'transform') finish(); }

    if (reduceMotion.matches) { finish(); return; }
    box.addEventListener('transitionend', onEnd);
    timer = setTimeout(finish, 320); // fallback if transitionend never fires
  }

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-po-close]')) track('po_keep', { po_audience: audience });
    if (e.target.closest('[data-po-dismiss], [data-po-close]')) close();
  });

  document.addEventListener('keydown', (e) => {
    // Escape does nothing: the only exits are the step buttons (No thanks / Keep browsing)
    if (root.hidden || closing || e.key !== 'Tab') return;
    // Focus trap within the visible step
    const items = Array.prototype.filter.call(
      steps[step].querySelectorAll('button, input, a[href]'),
      (el) => !el.disabled && el.getClientRects().length
    );
    if (!items.length) { e.preventDefault(); return; }
    const first = items[0];
    const last = items[items.length - 1];
    if (!steps[step].contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ---------- Step 1: audience ----------
  root.querySelectorAll('[data-po-answer]').forEach((btn) => {
    btn.addEventListener('click', () => {
      audience = btn.dataset.poAnswer;
      root.querySelectorAll('[data-po-aud]').forEach((el) => { el.hidden = el.dataset.poAud !== audience; });
      emailInput.placeholder = (audience === 'home' ? d.phHome : d.phBusiness) || '';
      track('po_answer', { po_audience: audience });
      setStep(2);
    });
  });

  // ---------- Step 2: email ----------
  emailForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const value = emailInput.value.trim();
    emailErr.textContent = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      emailErr.textContent = d.errEmail || '';
      track('po_email_error');
      emailInput.focus();
      return;
    }
    emailBtn.disabled = true;

    const p = currentPrices();
    Promise.all([
      subscribe({ email: value, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }),
      post('events', { data: { type: 'event', attributes: {
        properties: {
          offer_code: d.code,
          offer_amount: Number(d.amount),
          offer_amount_text: d.amountText,
          claim_code: d.claim || '',
          product_title: d.product,
          product_url: d.url,
          product_image: d.img,
          product_price: p[0],
          price_with_code: p[1],
          brand: d.brand,
          audience,
          variant_id: String(variantId),
          cart_url: cartUrl(),
          authorized: d.authorized === 'true',
          point_warranty: d.ptWarranty || '',
          point_shipping: d.ptShipping || '',
          point_returns: d.ptReturns || ''
        },
        metric: { data: { type: 'metric', attributes: { name: d.metric } } },
        profile: { data: { type: 'profile', attributes: { email: value } } } } } })
    ]).then(() => {
      email = value;
      setFlag('localStorage', DONE);
      track('po_email', { po_audience: audience });
      setStep(3);
    }).catch(() => {
      emailErr.textContent = d.errSend || '';
      emailBtn.disabled = false;
    });
  });

  // ---------- Step 3: phone ----------
  function showSuccess(sub) {
    root.querySelectorAll('[data-po-sub]').forEach((el) => { el.hidden = el.dataset.poSub !== sub; });
    setStep(4);
  }

  phoneForm.addEventListener('submit', (e) => {
    e.preventDefault();
    let digits = phoneInput.value.replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1); // pasted with the +1
    phoneErr.textContent = '';
    if (digits.length !== 10) {
      phoneErr.textContent = d.errPhone || '';
      phoneInput.focus();
      return;
    }
    phoneBtn.disabled = true;
    subscribe({
      email,
      phone_number: '+1' + digits,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } }, sms: { marketing: { consent: 'SUBSCRIBED' } } }
    }).then(() => {
      track('po_phone', { po_audience: audience });
      showSuccess('sms');
    }).catch(() => {
      phoneErr.textContent = d.errSend || '';
      phoneBtn.disabled = false;
    });
  });
  root.querySelector('[data-po-skip]').addEventListener('click', () => {
    track('po_sms_skip', { po_audience: audience });
    showSuccess('email');
  });

  // ---------- Step 4: copy, prices, add to cart ----------
  const copyBtn = root.querySelector('[data-po-copy]');
  const copyLabels = copyBtn.querySelectorAll('[data-po-copy-l]');
  const copyStatus = root.querySelector('[data-po-copy-status]');
  let copyTimer = null;

  function showCopied() {
    copyLabels[0].classList.add('is-off');
    copyLabels[1].classList.remove('is-off');
    copyStatus.textContent = copyStatus.dataset.text || '';
    clearTimeout(copyTimer);
    copyTimer = setTimeout(() => {
      copyLabels[0].classList.remove('is-off');
      copyLabels[1].classList.add('is-off');
      copyStatus.textContent = '';
    }, 2000);
  }
  function copyFallback() {
    const ta = document.createElement('textarea');
    ta.value = d.code;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    root.appendChild(ta);
    ta.select();
    try { if (document.execCommand('copy')) showCopied(); } catch (e) {}
    ta.remove();
    copyBtn.focus();
  }
  copyBtn.addEventListener('click', () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(d.code).then(showCopied, copyFallback);
    } else {
      copyFallback();
    }
  });

  const wasEl = root.querySelector('[data-po-was]');
  const nowEl = root.querySelector('[data-po-now]');
  document.addEventListener('variant:change', (e) => {
    const id = e.detail && e.detail.variantId;
    if (!id || !prices[id]) return;
    variantId = String(id);
    wasEl.textContent = prices[id][0];
    nowEl.textContent = prices[id][1];
  });

  // Same path as the promo line's triggerATC(): that button runs the order-option validation.
  function findRealATC() {
    return document.querySelector('.sticky-buy-box [data-add-to-checkout]')
      || document.querySelector('form[action*="/cart/add"] button[type="submit"]')
      || document.querySelector('#stickyATC [data-add-to-checkout]');
  }

  atcBtn.addEventListener('click', async () => {
    atcBtn.disabled = true;
    await window.CFS.cartCodes.add(d.code);
    track('po_atc', { po_audience: audience });
    const realBtn = findRealATC();
    if (realBtn) realBtn.click();
    // Closed even if validation blocked the add, so its message is visible; the code stays applied.
    close();
    atcBtn.disabled = false;
  });

  // ---------- Timing: data-delay seconds after load, unless the cart already has this code ----------
  // With data-exit-intent (café pages): the timer or exit intent, whichever comes first, once the visitor has been on
  // the page 5s. Desktop: the cursor leaves through the top. Phone: after scrolling down a viewport height, a scroll
  // back up of 30% of the viewport height within 400ms. Listeners are passive and removed once either fires.
  const EXIT_MIN_MS = 5000;
  const FLICK_MS = 400;
  function start() {
    const inCart = window.CFS.cartCodes.read().then((codes) => {
      const own = (d.code || '').toLowerCase();
      return !!(codes && codes.some((c) => c.toLowerCase() === own));
    });
    let triggered = false;
    let timer = 0;
    const exitOn = d.exitIntent === 'true';
    const go = () => {
      if (triggered) return;
      triggered = true;
      clearTimeout(timer);
      if (exitOn) {
        document.removeEventListener('mouseout', onMouseOut);
        window.removeEventListener('scroll', onScroll);
      }
      inCart.then((has) => { if (!has) tryOpen(); });
    };
    const settled = () => performance.now() >= EXIT_MIN_MS;
    const isDesktop = () => window.innerWidth >= DESKTOP_BP;
    function onMouseOut(e) {
      if (!e.relatedTarget && e.clientY <= 0 && isDesktop() && settled()) go();
    }
    let armed = false;
    let samples = [];
    function onScroll() {
      if (isDesktop()) return;
      const now = performance.now();
      const y = window.scrollY;
      const vh = window.innerHeight;
      if (y >= vh) armed = true;
      samples.push([now, y]);
      samples = samples.filter((s) => now - s[0] <= FLICK_MS);
      if (!armed || !settled()) return;
      const peak = Math.max(...samples.map((s) => s[1]));
      if (peak - y >= vh * 0.3) go();
    }
    timer = setTimeout(go, Math.max(0, Number(d.delay) || 0) * 1000);
    if (exitOn) {
      document.addEventListener('mouseout', onMouseOut, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
